export default __webpack_public_path__ + "static/media/power_off_color.04e716dc.png";